<!-- -------------------------------------------------------------- -->
<!-- added dialog -->
<!-- -------------------------------------------------------------- -->

<p class="p-x-24 f-s-14 p-y-10">Invoice Successfully Updated.</p>

<div mat-dialog-actions>
  <button mat-flat-button mat-dialog-close>Ok</button>
</div>
